export default {
  common: {
    nav: {
      home: "Beranda",
      find_offer_help: "Cari / Tawarkan bantuan",
      celebrate: "Rayakan kehidupan",
      family_tree: "Pohon keluarga",
      events: "Acara",
      civic_reports: "Laporan warga",
      neighborhood_pulse: "Denyut lingkungan",
      weather: "Cuaca",
      nature: "Alam",
      marketplace: "Pasar",
      news: "Berita",
      causes: "Tujuan mulia",
      more: "Lainnya",
    },
    header: { sign_in: "Masuk", join: "Gabung Social Pulse", language: "Bahasa", search: "Cari" },
    tagline: "Menghubungkan komunitas · Memberdayakan kehidupan · Membangun modal sosial",
    locality: { viewing_from: "Anda melihat dari", change: "Ubah", set_your_location: "Atur lokasi Anda" },
    news: { title: "Ringkasan harian Anda.", play_briefing: "Putar ringkasan harian", listen: "Dengarkan", translate: "Terjemahkan" },
  },
};
